"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Angry;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Angry(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    id: "Emojis",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100
  }, props), /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("style", {
    dangerouslySetInnerHTML: {
      __html: ".cls-1{fill:#231f20;}"
    }
  })), /*#__PURE__*/_react["default"].createElement("title", null, "icon"), /*#__PURE__*/_react["default"].createElement("g", {
    id: "angry"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "outline-2",
    "data-name": "outline"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    className: "cls-1",
    d: "M50,7.5A42.5,42.5,0,1,0,92.5,50,42.548,42.548,0,0,0,50,7.5Zm0,80A37.5,37.5,0,1,1,87.5,50,37.542,37.542,0,0,1,50,87.5Z"
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    className: "cls-1",
    cx: "33.899",
    cy: "54.5",
    r: 5
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: "cls-1",
    d: "M40.785,49.405A11.463,11.463,0,0,0,43.1,49.18a2.5,2.5,0,0,0-1.01-4.9c-.662.127-6.517,1.06-8.831-5.572a2.5,2.5,0,0,0-4.721,1.648C31.054,47.555,36.772,49.405,40.785,49.405Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: "cls-1",
    d: "M63.629,63.989a24.559,24.559,0,0,0-27.264,7.942,2.5,2.5,0,0,0,3.916,3.109A19.559,19.559,0,0,1,62,68.716a2.5,2.5,0,0,0,1.632-4.727Z"
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    className: "cls-1",
    cx: "66.101",
    cy: "54.5",
    r: 5
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: "cls-1",
    d: "M69.922,37.175a2.5,2.5,0,0,0-3.185,1.536c-2.312,6.623-8.157,5.7-8.828,5.572a2.5,2.5,0,0,0-1.013,4.9,11.463,11.463,0,0,0,2.319.225c4.013,0,9.731-1.851,12.243-9.046A2.5,2.5,0,0,0,69.922,37.175Z"
  }))));
}